/*
 * (c) copyright 2021 International Road Dynamics Inc. and related companies.
 * All rights reserved.
 * Copyright as an unpublished work.
 *
 * This file contains confidential information of International
 * Road Dynamics Inc. and related companies, and should be treated as proprietary
 * and confidential.
 *
 * The use, copying, disclosure or modification of the
 * programs and/or source code is prohibited unless
 * otherwise provided for in the license or confidentiality
 * agreements.
 *
 * Any copy must contain this copyright notice.
 */

import React from 'react'

import Link from '@material-ui/core/Link'

import './PageFooter.css'

function PageFooter () {
  return (
    <footer>
      <div className="logo">
        <Link target="_blank" href="https://www.irdinc.com">
          <img src="/img/logos/ird_logo.png" alt="IRD Logo" />
        </Link>
      </div>
      <div className="copyright">
        Copyright &copy; {new Date().getFullYear()} International Road Dynamics Inc. All Rights Reserved.
      </div>
    </footer>
  )
}

export default PageFooter
